import classNames from 'classnames';
const headerDecorationsCss = "h18z9cf7";
const headerDecorationCircleCss = "h1av0tch";
const headerDecorationCircleMediumCss = "h1wjhvha";
const headerDecorationCircleLargeCss = "h1xorhgl";
const headerDecorationCircleIconCss = "hk5iywa";
const headerDecorationCircleLeftCss = "h2uyahp";
const headerDecorationCircleCenterCss = "h1a1akoj";
const headerDecorationCircleRightCss = "h1ba703x";
export const CallieHeaderDecorations = () => <div className={headerDecorationsCss} aria-hidden="true">
    <span className={classNames(headerDecorationCircleCss, headerDecorationCircleLargeCss, headerDecorationCircleIconCss)} />
    <span className={classNames(headerDecorationCircleCss, headerDecorationCircleMediumCss, headerDecorationCircleLeftCss)} />
    <span className={classNames(headerDecorationCircleCss, headerDecorationCircleMediumCss, headerDecorationCircleCenterCss)} />
    <span className={classNames(headerDecorationCircleCss, headerDecorationCircleMediumCss, headerDecorationCircleRightCss)} />
  </div>;

require("./header_decorations.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./header_decorations.js");